import React, { useEffect, useRef, useState } from 'react';
import { Table } from 'reactstrap';
import { Content } from '../../pages/dashboard/dashboardInterface';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const DashBoardTable = ({
  data,
  filter,
  setFilter,
  isPending,
  setPage,
}: {
  data: Content[];
  filter: string;
  setFilter: React.Dispatch<React.SetStateAction<string>>;
  isPending: boolean;
  setPage: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const handleClickFilter = (value: string) => {
    setPage(0);
    setFilter(value);
    setOpenFilter(false);
  };
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpenFilter(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const [translation] = useTranslation('common');
  const filters = [
    { key: translation('DASHBOARD.ALL'), value: '' },
    { key: translation('DASHBOARD.CONFIRMED'), value: 'CONFIRMED' },
    { key: translation('DASHBOARD.PENDING'), value: 'PENDING' },
    { key: translation('DASHBOARD.CANCELED'), value: 'CANCELED' },
  ];
  return (
    <div style={{ minHeight: openFilter ? '200px' : 'auto' }}>
      <table width={'100%'} className="dashbboard-table">
        <thead className="dashboard-thead">
          <tr>
            <th className="sticky-col">
              {translation('DASHBOARD.BOOKING_ID')}
            </th>
            <th>{translation('DASHBOARD.CUSTOMER_NAME')}</th>
            <th>{translation('DASHBOARD.ACTIVITY_NAME')}</th>
            <th>{translation('DASHBOARD.EMAIL')}</th>
            <th className="filter-table-heading">
              <img
                onClick={() => setOpenFilter(!openFilter)}
                width={16}
                height={16}
                src={
                  filter !== ''
                    ? '/assets/table-filter-active.svg'
                    : '/assets/table-filter.svg'
                }
                alt=""
                crossOrigin="anonymous"
              />{' '}
              {translation('DASHBOARD.STATUS')}
              {openFilter ? (
                <div className="table-status-filter" ref={dropdownRef}>
                  {filters.map((item) => (
                    <div
                      style={{
                        background: filter === item.value ? '#E2E9FD' : 'white',
                      }}
                      onClick={() => handleClickFilter(item.value)}
                      className={`table-filter-item ${item.value}`}
                      key={item.key}
                    >
                      {item.key}
                    </div>
                  ))}
                </div>
              ) : null}
            </th>
            <th>{translation('DASHBOARD.PRICE')}</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => (
            <tr key={index}>
              <td className="sticky-col">
                <h6 className="table-bookingid">{item?.bookingId}</h6>
                <p className="td-date">
                  {moment(item?.bookingTimestamp).format(
                    'DD/MM/YYYY - HH:mm A'
                  )}
                </p>
              </td>
              <td>{item?.customerName}</td>
              <td>{item?.activityName}</td>
              <td>{item?.customerEmail}</td>
              <td>
                <div className={`table-td-status ${item?.bookingStatus}`}>
                  <div className={`dot ${item?.bookingStatus}`}></div>
                  {item?.bookingStatus}
                </div>
              </td>
              <td>
                {`${item?.currency}
                ${item?.totalPrice?.toFixed(2)}`}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DashBoardTable;
